<template>
    <div class="box">
        <div class="field">
            <label class="label"> {{ translate("page.admin_academy_results.points_awarded_for_each_match_won") }}: </label>

            <div class="control">
                <input
                    class="input"
                    type="number"
                    min="1"
                    max="100"
                    v-model="pointsForWonMatch"
                    onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57);"
                />
            </div>
        </div>
        <div class="mb-2">
            <Checkbox2 v-model="promoteSubmissionEnabled">
                {{ translate("event_ranking.rule.promoteSubmission.label1") }}
            </Checkbox2>
        </div>
        <div class="field">
            <div class="control">
                <input class="input" type="number" v-model="multiplierForSubmissionWin" :disabled="!promoteSubmissionEnabled" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useAddRuleStore } from "./addRuleStore";
    import { computed, onMounted, onUnmounted, ref, watch } from "vue";
    import { eventBus, SELECTED_CATEGORIES_UPDATE } from "./eventBus";
    import { translate } from "../../Common/translations";
    import Checkbox2 from "../../Common/Checkbox2.vue";
    import { isIntegerOrFloatGreaterThan0 } from "../../Common/numbers";

    const addRuleStore = useAddRuleStore();

    const pointsForWonMatch = computed({
        get: () => addRuleStore.pointsForWonMatch,
        set: value => {
            addRuleStore.pointsForWonMatch = value;
            updateSelectedRuleCandidate();
        },
    });

    const promoteSubmissionEnabled = ref(false);

    watch(promoteSubmissionEnabled, () => {
        updateSelectedRuleCandidate();
    });

    const multiplierForSubmissionWin = computed({
        get: () => addRuleStore.multiplierForSubmissionWin,
        set: value => {
            addRuleStore.multiplierForSubmissionWin = value;
            updateSelectedRuleCandidate();
        },
    });

    function updateSelectedRuleCandidate() {
        addRuleStore.selectedRule = {
            rule: "scoreForWonMatches",
            input: {
                selectedCategories: addRuleStore.selectedCategoriesArray,
                pointsForWonMatch: Number(addRuleStore.pointsForWonMatch),
                multiplierForSubmissionWin: promoteSubmissionEnabled.value ? Number(addRuleStore.multiplierForSubmissionWin) : null,
            },
        };

        addRuleStore.validRule =
            addRuleStore.selectedRule.input.selectedCategories.length > 0 &&
            addRuleStore.pointsForWonMatch > 0 &&
            (promoteSubmissionEnabled.value ? isIntegerOrFloatGreaterThan0(multiplierForSubmissionWin.value) : true);
    }

    onMounted(() => {
        updateSelectedRuleCandidate();

        eventBus.$on(SELECTED_CATEGORIES_UPDATE, () => {
            updateSelectedRuleCandidate();
        });
    });

    onUnmounted(() => {
        eventBus.$off(SELECTED_CATEGORIES_UPDATE);
    });
</script>

<style scoped></style>
